/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PageMessageVisitSummaryDto } from '../model';
/**
 * AdminMessageControllerApi - axios parameter creator
 * @export
 */
export const AdminMessageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [patientId] 
         * @param {number} [doctorId] 
         * @param {Array<'NEW' | 'PENDING' | 'RESPONDED' | 'DONE' | 'UNIDIRECTIONAL'>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageVisitsSummaries: async (patientId?: number, doctorId?: number, statuses?: Array<'NEW' | 'PENDING' | 'RESPONDED' | 'DONE' | 'UNIDIRECTIONAL'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/message/visit/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (doctorId !== undefined) {
                localVarQueryParameter['doctorId'] = doctorId;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMessageControllerApi - functional programming interface
 * @export
 */
export const AdminMessageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMessageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [patientId] 
         * @param {number} [doctorId] 
         * @param {Array<'NEW' | 'PENDING' | 'RESPONDED' | 'DONE' | 'UNIDIRECTIONAL'>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageVisitsSummaries(patientId?: number, doctorId?: number, statuses?: Array<'NEW' | 'PENDING' | 'RESPONDED' | 'DONE' | 'UNIDIRECTIONAL'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<PageMessageVisitSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageVisitsSummaries(patientId, doctorId, statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminMessageControllerApi - factory interface
 * @export
 */
export const AdminMessageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMessageControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [patientId] 
         * @param {number} [doctorId] 
         * @param {Array<'NEW' | 'PENDING' | 'RESPONDED' | 'DONE' | 'UNIDIRECTIONAL'>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageVisitsSummaries(patientId?: number, doctorId?: number, statuses?: Array<'NEW' | 'PENDING' | 'RESPONDED' | 'DONE' | 'UNIDIRECTIONAL'>, options?: any): Promise<PageMessageVisitSummaryDto> {
            return localVarFp.getMessageVisitsSummaries(patientId, doctorId, statuses, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminMessageControllerApi - object-oriented interface
 * @export
 * @class AdminMessageControllerApi
 * @extends {BaseAPI}
 */
export class AdminMessageControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} [patientId] 
     * @param {number} [doctorId] 
     * @param {Array<'NEW' | 'PENDING' | 'RESPONDED' | 'DONE' | 'UNIDIRECTIONAL'>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMessageControllerApi
     */
    public getMessageVisitsSummaries(patientId?: number, doctorId?: number, statuses?: Array<'NEW' | 'PENDING' | 'RESPONDED' | 'DONE' | 'UNIDIRECTIONAL'>, options?: AxiosRequestConfig) {
        return AdminMessageControllerApiFp(this.configuration).getMessageVisitsSummaries(patientId, doctorId, statuses, options).then((request) => request(this.axios, this.basePath));
    }
}
